export default class DtoLithology {
    constructor(obj) {
        this.idStation = obj.idStation
        this.lithologyCode = obj.lithologyCode
        this.order = obj.order
        this.thickness = obj.thickness
        this.comment = obj.comment
    }
}